import React from "react";
import { AuditLog } from "@common/types/auditLog";
import {
    ChangeComponent,
    defineTransactionChangeComponent,
} from "../helpers/defineTransactionChangeComponent";
import { ActivityTimelineLog } from "@design-system/ActivityTimeline/ActivityTimeline";
import { TransactionLogTransferMatchContent } from "./TransactionLogTransferMatchContent";
import { TransactionLogAccrualMatchContent } from "./TransactionLogAccrualMatchContent";
import { TransactionLogCounterpartyContent } from "./TransactionLogCounterpartyContent";
import { TransactionLogSplitContent } from "./TransactionLogSplitContent";
import { TransactionLogCategoryContent } from "./TransactionLogCategoryContent";
import { TransactionLogCreatedContent } from "./TransactionLogCreatedContent";
import { TransactionLogEntityContent } from "./TransactionLogEntityContent";
import { TransactionLogAccountContent } from "./TransactionLogAccountContent";
import { TransactionLogMemoContent } from "./TransactionLogMemoContent";
import { TransactionLogFieldReviewContent } from "./TransactionLogFieldReviewContent";
import { TransactionLogScheduleRuleSkipContent } from "./TransactionLogScheduleRuleSkipContent";

interface Props {
    log: AuditLog;
}

export const TransactionHistory: React.FC<Props> = ({ log }) => {
    const changeComponent = defineTransactionChangeComponent(log);
    let content: React.ReactNode | null = null;

    switch (changeComponent) {
        case ChangeComponent.TRANSFER:
            content = <TransactionLogTransferMatchContent log={log} />;
            break;
        case ChangeComponent.ACCRUAL_MATCH:
            content = <TransactionLogAccrualMatchContent log={log} />;
            break;
        case ChangeComponent.CREATED:
            content = <TransactionLogCreatedContent log={log} />;
            break;
        case ChangeComponent.CATEGORY:
            content = <TransactionLogCategoryContent log={log} />;
            break;
        case ChangeComponent.COUNTERPARTY:
            content = <TransactionLogCounterpartyContent log={log} />;
            break;
        case ChangeComponent.SPLIT:
            content = <TransactionLogSplitContent log={log} />;
            break;
        case ChangeComponent.ENTITY:
            content = <TransactionLogEntityContent log={log} />;
            break;
        case ChangeComponent.ACCOUNT:
            content = <TransactionLogAccountContent log={log} />;
            break;
        case ChangeComponent.MEMO:
            content = <TransactionLogMemoContent log={log} />;
            break;
        case ChangeComponent.FIELD_REVIEW:
            content = <TransactionLogFieldReviewContent log={log} />;
            break;
        case ChangeComponent.SCHEDULE_RULE_SKIP:
            content = <TransactionLogScheduleRuleSkipContent log={log} />;
            break;
        default:
            break;
    }

    return (
        <ActivityTimelineLog
            timestamp={log.createdAt}
            data-testid="transaction-details-history-log"
        >
            {content}
        </ActivityTimelineLog>
    );
};
